module.exports = __webpack_public_path__ + "assets/img/u7.24d0c270.png";